import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../ui/alert-dialog';
import { Button } from '../../ui/button';
import { Loader2, RotateCcw } from 'lucide-react';

const Stat = ({ label, value, testId }) => (
  <div className="rounded-lg border p-3 text-center">
    <p className="text-xl font-bold" data-testid={testId}>{value}</p>
    <p className="text-xs text-muted-foreground">{label}</p>
  </div>
);

const ResetConfirmDialog = ({ preview, onCancel, onConfirm, busy }) => (
  <AlertDialog open={!!preview} onOpenChange={(open) => !open && !busy && onCancel()}>
    <AlertDialogContent className="bg-background" data-testid="reset-confirm-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle>Reset learner progress?</AlertDialogTitle>
        <AlertDialogDescription>
          Completion, quiz attempts and scores in the selected scope will be cleared. Course assignments and issued certificates are kept.
        </AlertDialogDescription>
      </AlertDialogHeader>
      {preview && (
        <div className="space-y-3">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
            <Stat label="Users selected" value={preview.selected_users} testId="reset-preview-users" />
            <Stat label="With progress" value={preview.users_with_progress} testId="reset-preview-users-with-progress" />
            <Stat label="Content items" value={preview.content_items} testId="reset-preview-content" />
            <Stat label="Assessments" value={preview.assessments} testId="reset-preview-assessments" />
          </div>
          <div className="rounded-md bg-muted/50 p-3 text-sm max-h-32 overflow-y-auto" data-testid="reset-preview-items">
            {preview.items.map(item => <p key={item}>• {item}</p>)}
          </div>
          {preview.users_with_certificates > 0 && (
            <p className="text-xs text-amber-600" data-testid="reset-preview-certificates">
              {preview.users_with_certificates} user(s) already hold a certificate. It stays valid, but the course goes back to in-progress.
            </p>
          )}
          {preview.users_with_progress === 0 && (
            <p className="text-xs text-muted-foreground">None of the selected users has started this course yet, so nothing will change.</p>
          )}
        </div>
      )}
      <AlertDialogFooter>
        <AlertDialogCancel disabled={busy} data-testid="reset-cancel-btn">Cancel</AlertDialogCancel>
        <Button onClick={onConfirm} disabled={busy} className="bg-amber-600 hover:bg-amber-700" data-testid="reset-confirm-btn">
          {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <RotateCcw className="h-4 w-4 mr-2" />}
          Reset Progress
        </Button>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export default ResetConfirmDialog;
